export default __webpack_public_path__ + "static/media/redWarning.34e6cffa.svg";